import moment from 'moment'

const MY_OFFSET = '+08:00'

export function formatMalaysiaDate(value, format = 'DD/MM/YYYY') {
  if (!value) return ''
  return moment.utc(value).utcOffset(MY_OFFSET).format(format)
}

export function formatMalaysiaDateTime(value, format = 'DD/MM/YYYY HH:mm:ss') {
  if (!value) return ''
  return moment.utc(value).utcOffset(MY_OFFSET).format(format)
}
